import * as React from 'react'
import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import Disclaimer from '../components/disclaimer/disclaimer'
import Menu from '../components/menu/menu'
import PopupNotifications from '../components/notifications/popupNotification/popupNotifications'
import PremiumDialog from '../components/informationWindow/premiumDialog'

import { Scrollbars } from 'react-custom-scrollbars-2'

import { PmCommonType, ScrolledPageAmountAndPositionType } from '../store/common/commonSliceTyping'
import { RootState } from '../store/rootReducer'
import { setAgeVerified } from '../store/common/commonSlice'
import ReactGA from 'react-ga4'

import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { initializeApp } from 'firebase/app'

import {
    changeScrolledPosition,
    switchPageOnNotScrolled,
    switchPageOnScrolled,
    switchUserOnActive,
    switchUserOnNotActive,
    unfixAppContainer,
    setIsLeavingPage,
    pageScrolled
} from '../store/common/commonSlice'
import Cookies from 'js-cookie'
import { memberFetch } from '../store/member/memberSlice'

import { Helmet } from 'react-helmet'
import i18next, { getLangFromPath } from '../i18next'
// @ts-ignore
import { FullPmState } from 'pm-js/types/pm'

import './app.sass'
import './../styles/global.sass'
import passiveSupported from '../utils/passiveSupported'
import { useInstanoti } from '../hooks/useInstanoti'
import usePosition from '../hooks/usePosition'
import usePmRequest from '../hooks/usePmRequest'
import AgeverifCloseButton from '../components/ageverifCloseButton/ageverifCloseButton'
import { ReportProvider } from '../components/report/reportPopup/reportPopup'
import CookieConsentBanner from '../components/CookieConsentBanner/CookieConsentBanner'
import { hydrateIgnoredUsers } from '../store/ephemeral/ephemeralSlice'
import { isUserAdmin } from '../utils/isUserPro'

// if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') require('./development.sass')

const App: React.FunctionComponent = ({ children }) => {
    const location = useLocation()
    const history = useHistory()
    const dispatch = useDispatch()
    useInstanoti()
    usePosition()
    usePmRequest()

    const isUserActive = useSelector<RootState, boolean>((state) => state.common.isUserActive)
    const isPageScrolled = useSelector<RootState, boolean>((state) => state.common.isPageScrolled)
    const isPageLoading = useSelector<RootState, boolean>((state) => state.common.isPageLoading)
    const isAppContainerFixed = useSelector<RootState, boolean>((state) => state.common.isAppContainerFixed)
    const isLeavingPage = useSelector<RootState, boolean>((state) => state.common.isLeavingPage)
    const swiperTopPosition = useSelector<RootState, number>((state) => state.common.swiperTopPosition)
    const scrollToTopBottom = useSelector<RootState, string>((state) => state.common.scrollToTopBottom)
    const scrolledPagesAmountAndPosition = useSelector<RootState, ScrolledPageAmountAndPositionType>(
        (state) => state.common.scrolledPagesAmountAndPosition
    )
    const isLoaderDisabled = useSelector<RootState, boolean>((state) => state.common.isLoaderDisabled)
    const pm_common = useSelector<RootState, PmCommonType>((state) => state.common.pm_common)

    const user = useSelector((state: RootState) => state.member.user)
    const triedLoad = useSelector((state: RootState) => state.member.triedLoad)
    const loadingCounter = useSelector((state: RootState) => state.member.loadingCounter)
    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)
    const pm = useSelector<RootState, FullPmState>((state) => state.pm)

    const [dailyCookie, setDailyCookie] = useState(false)
    const [activityTimeout, setActivityTimeout] = useState(null)
    const [isFirstLoading, setIsFierstLoading] = useState(true)

    const ref = useRef(null)
    const appContainerRef = useRef<HTMLDivElement>(null)
    const firstLoadRef = useRef(null)
    // let dialog = null
    const root = typeof window !== 'undefined' ? document.getElementById('root') : null
    const isDailyCookieInited = useRef(false)

    const isNecessaryToSaveThePosition = () => {
        const adressLastItem = location?.pathname.split('/').reverse()[0]
        return (
            (adressLastItem === '' ||
                adressLastItem === 'en' ||
                adressLastItem === 'ru' ||
                adressLastItem === 'membres' ||
                location.pathname.includes('tags') ||
                location.pathname.includes('photo') ||
                location.pathname.includes('video')) &&
            !location.pathname.includes('les-meilleures-photos') &&
            !location.pathname.includes('/flashing/') &&
            !location.pathname.includes('ephemeral')
        )
    }

    const scrollPreviousPosition = () => {
        if (isNecessaryToSaveThePosition) {
            if (location.pathname.includes('photo') || location.pathname.includes('video')) {
                ref.current.scrollTop(swiperTopPosition)
            } else {
                ref.current.scrollTop(scrolledPagesAmountAndPosition.scrollPosition)
            }
        }
    }

    const beginningUserActivity = () => {
        setActivityTimeout(new Date())
        if (!isUserActive) dispatch(switchUserOnActive())
    }

    useEffect(() => {
        if (typeof window !== 'undefined' && isFirstLoading) {
            const loader = document.getElementById('globalLoader')
            if (loader)
                setTimeout(() => {
                    setIsFierstLoading(false)
                    loader.remove()
                }, 150)
        }
    }, [])

    useEffect(() => {
        root.addEventListener('click', beginningUserActivity)
        root.addEventListener('touchstart', beginningUserActivity, passiveSupported)
        return () => {
            root.removeEventListener('click', beginningUserActivity)
            root.removeEventListener('touchstart', beginningUserActivity)
        }
    }, [])

    useEffect(() => {
        setTimeout(() => {
            if (!firstLoadRef.current && !user && !triedLoad) {
                firstLoadRef.current = true
                dispatch(memberFetch({}))
            }
        }, 500)
    }, [])
    // This useEffect is needed for authorization when opening app

    useEffect(() => {
        if (loggedIn) {
            dispatch({ type: 'PM_CONNECT_TO_SERVER', url: process.env.RAZZLE_PM_SERVER_URL, user: user })
        } else {
            // @ts-ignore
            if (pm.status == 'connected') {
                dispatch({ type: 'PM_DISCONNECT_FROM_SERVER' })
            }
        }
    }, [loggedIn])

    const timeoutRef = useRef(null)

    useEffect(() => {
        const connectPmServer = () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
                return
            }
            if (pm_common.state !== 'active')
                setTimeout(
                    () => dispatch({ type: 'PM_CONNECT_TO_SERVER', url: process.env.RAZZLE_PM_SERVER_URL, user: user }),
                    10
                )
        }

        const disconnectSeconds = 5 * 60

        const disconnectPmServer = () => {
            if (pm_common.state !== 'active')
                timeoutRef.current = setTimeout(() => {
                    dispatch({ type: 'PM_DISCONNECT_FROM_SERVER' })
                    console.log(`PM server disconnected by timeout ${disconnectSeconds}s`)
                    timeoutRef.current = null
                }, disconnectSeconds * 1000)
        }

        if (loggedIn) {
            // This condition is necessary to prevent videoCall splitting chat when change language in active call.
            if (pm_common.state === 'active' || pm_common.state === 'connecting' || pm_common.state === 'connected')
                history.go(0)
            //
            if (pm.status == 'connected') {
                dispatch({ type: 'PM_DISCONNECT_FROM_SERVER' })
                setTimeout(
                    () => dispatch({ type: 'PM_CONNECT_TO_SERVER', url: process.env.RAZZLE_PM_SERVER_URL, user: user }),
                    10
                )
            }
            if (typeof window !== 'undefined') window.addEventListener('blur', disconnectPmServer)
            if (typeof window !== 'undefined') window.addEventListener('focus', connectPmServer)
        }
        return () => {
            if (typeof window !== 'undefined') window.removeEventListener('blur', disconnectPmServer)
            if (typeof window !== 'undefined') window.removeEventListener('focus', connectPmServer)
        }
    }, [i18next.language])

    useEffect(() => {
        const scrollContainer = appContainerRef.current

        switch (scrollToTopBottom) {
            case 'top':
                ref.current.scrollToTop()
                if (scrollContainer) scrollContainer.scrollTo(0, 0)
                dispatch(pageScrolled())
                break
            case 'bottom':
                ref.current.scrollToBottom()
                if (scrollContainer) scrollContainer.scrollTo(0, document.body.scrollHeight)
                dispatch(pageScrolled())
                break
            case 'top-smooth':
                ref.current.view.scroll({
                    top: 0,
                    behavior: 'smooth'
                })
                if (scrollContainer) scrollContainer.scrollTo({ top: 0, behavior: 'smooth' })
                dispatch(pageScrolled())
                break
            default:
                dispatch(pageScrolled())
                break
        }
    }, [scrollToTopBottom])

    useEffect(() => {
        const timeout = setTimeout(() => {
            dispatch(switchUserOnNotActive())
        }, 3000)
        return () => {
            clearTimeout(timeout)
        }
    }, [activityTimeout])

    useEffect(() => {
        dispatch(unfixAppContainer())
        // dialog = document.getElementById('dailyDialog')
        if (!Cookies.get('Visited') && !isDailyCookieInited.current && !location.search.includes('nodisclaimer=1')) {
            isDailyCookieInited.current = true
            setTimeout(() => {
                setDailyCookie(true)
            }, 100)
        }
        const isBot = /bot|crawl|slurp|spider/i.test(navigator.userAgent)
        if (Cookies.get('Visited') || isBot) {
            setTimeout(() => setDailyCookie(false), 101)
            dispatch(setAgeVerified())
        } else {
            // if (!dialog) history.go(0)
            // @ts-ignore
            document.getElementById('root').style.overflowY = 'hidden'
        }
        // eslint-disable-next-line
    }, [location, loadingCounter])

    useEffect(() => {
        if (Cookies.get('Visited')) dispatch(setAgeVerified())
    }, [dailyCookie])

    useEffect(() => {
        if (!isPageLoading && isNecessaryToSaveThePosition()) {
            setTimeout(() => scrollPreviousPosition(), 500)
        }
    }, [isPageLoading, swiperTopPosition, location.pathname])

    useEffect(() => {
        const consent = Cookies.get('cookieConsent')
        if (window && consent === 'accepted') {
            ReactGA.initialize('UA-6283810-3')
        }
    }, [])

    useEffect(() => {
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
        //@ts-ignore
        if (!isTouchDevice) return

        const scrollContainer = ref.current.container.firstChild as HTMLElement
        //@ts-ignore
        if (!scrollContainer) return

        const handleNativeScroll = () => {
            if (isPageLoading) return

            window.dispatchEvent(
                new CustomEvent('appScroll', {
                    detail: { scrollTop: scrollContainer.scrollTop }
                })
            )
        }

        scrollContainer.addEventListener('scroll', handleNativeScroll, { passive: true })
        return () => scrollContainer.removeEventListener('scroll', handleNativeScroll)
    }, [isPageLoading])

    //@ts-ignore
    useEffect(() => {
        const checkAndApplyBlur = () => {
            const isVerified = Cookies.get('Visited') === 'yes'

            document.querySelectorAll('img').forEach((img) => {
                img.style.filter = isVerified ? '' : 'blur(18px)'
            })

            return !isVerified
        }

        const shouldObserve = checkAndApplyBlur()

        if (shouldObserve) {
            const observer = new MutationObserver(checkAndApplyBlur)
            observer.observe(document.body, {
                childList: true,
                subtree: true
            })

            const cookieCheckInterval = setInterval(() => {
                if (Cookies.get('Visited') === 'yes') {
                    checkAndApplyBlur()
                    clearInterval(cookieCheckInterval)
                }
            }, 1000)

            return () => {
                observer.disconnect()
                clearInterval(cookieCheckInterval)
            }
        }
    }, [])

    useEffect(() => {
        dispatch(hydrateIgnoredUsers())
    }, [])

    useEffect(() => {
        if (window) {
            ReactGA.ga('send', 'pageview', location.pathname + location.search)
        }
    }, [location.pathname, location.search])

    useEffect(() => {
        if (
            typeof window === 'undefined' ||
            !('serviceWorker' in navigator) ||
            !loggedIn ||
            !isUserAdmin(user.member_type)
        )
            return

        const firebaseConfig = {
            apiKey: 'AIzaSyBCgtDAdEClZUPWHFVTDfzueziNCNoU2y0',
            authDomain: 'bobvoyeur-push.firebaseapp.com',
            projectId: 'bobvoyeur-push',
            storageBucket: 'bobvoyeur-push.firebasestorage.app',
            messagingSenderId: '1067272506883',
            appId: '1:1067272506883:web:4b109f5fead669ca9ec836',
            measurementId: 'G-H778FKNGML'
        }

        const app = initializeApp(firebaseConfig)

        const init = async () => {
            const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')
            await navigator.serviceWorker.ready

            const messaging = getMessaging(app)
            const permission = await Notification.requestPermission()

            if (permission === 'granted') {
                const token = await getToken(messaging, {
                    vapidKey: 'BCCeogZEDKKe2m3fx5ZS77-gH4Y-8HGDhx31GVcQnI5QkeSL-D2aI3gq01wRDxzHO4nOkGe4l_4GLxMO-Rtcbu0',
                    serviceWorkerRegistration: registration
                })
                onMessage(messaging, (payload) => {
                    console.log('foreground message:', payload)
                    alert(payload.notification.title)
                })
                navigator.clipboard.writeText(token)
                console.log(token)
            }
        }

        init()
    }, [loggedIn])

    return (
        <Scrollbars
            ref={ref}
            onScrollStart={() => beginningUserActivity()}
            onUpdate={(values) => {
                if (values.top == 0 && isPageScrolled) {
                    dispatch(switchPageOnNotScrolled())
                } else {
                    !isPageScrolled && values.top > 0.001 && dispatch(switchPageOnScrolled())
                }

                if (isLeavingPage) {
                    dispatch(setIsLeavingPage(false))
                    dispatch(
                        changeScrolledPosition({
                            scrollPosition: Math.ceil(values.top * values.scrollHeight) - values.clientHeight
                        })
                    )
                }
            }}
            universal
            style={{ width: '100%', height: '100vh' }}
            renderThumbVertical={(props) => <div {...props} style={{ background: '#cecece', borderRadius: '4px' }} />}
        >
            <Helmet>
                <html lang={getLangFromPath(location.pathname)} />
                {/*<link rel="canonical" href={location.pathname} />*/}
            </Helmet>
            <div
                ref={appContainerRef}
                className={`${
                    isAppContainerFixed || location.pathname.includes('/pm/')
                        ? 'app_container modalOpen'
                        : 'app_container'
                } ${isFirstLoading ? 'contentLoading' : ''}`}
            >
                <ReportProvider>{children}</ReportProvider>
                <Menu />
                <AgeverifCloseButton />
                <PopupNotifications />
                {isPageLoading && !isLoaderDisabled && (
                    <div className="loading">
                        <div className="lds-dual-ring"></div>
                    </div>
                )}
                <div className="popupDialogs">
                    <PremiumDialog />
                </div>
                {dailyCookie && <Disclaimer setDailyCookie={setDailyCookie} />}
            </div>
            {!dailyCookie && <CookieConsentBanner />}
        </Scrollbars>
    )
}

export default App
